import FormField from '@/shared/components/forms/WaveUIForm_V2/types/formField.type';

const metadataFormFieldVisibilityChangeHandler = (
  fieldNames: string[],
  formsList: FormField[][],
): FormField[][] => {
  return formsList.map((form) =>
    form.map((field) => {
      if (fieldNames.some((name) => field.field_props.name === name)) {
        return { ...field, isVisible: true } as FormField;
      }

      return { ...field, isVisible: false } as FormField;
    }),
  );
};

export default metadataFormFieldVisibilityChangeHandler;
